<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="frontmatter">
<header>
<h1 class="FMH"><span aria-label="8" id="pg_8" role="doc-pagebreak">Tools and Materials</span></h1>
</header>
<p class="fbm-quote">The basis of zero waste crafting is to reuse things that you have around you, so most of these projects can be made from things that you can find in your home. Once you’ve sourced your materials it’s just a case of having a few basic tools and you’re good to go.</p>
<figure class="IMG"><span aria-label="9" id="pg_9" role="doc-pagebreak"><img alt="" class="img100" src="images/pg9.jpg"/>
</span></figure>
<p class="bhead"><samp class="SANS_Milliard_ExtraLight_229">MATERIALS</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Fabric</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">Lots of the fabrics for these projects come from clothes. With 80% of clothes in second-hand shops ending up in landfill, it’s much better to cut them up and turn them into a tea cosy than leave them hanging in a shop. But all of the projects in this book are about rethinking what existing objects are and what new life they can have with some simple transformations, so don’t be afraid to get the scissors out.</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Plastics</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">Make sure you clean out things like milk bottles thoroughly and then leave them somewhere to dry properly. The last thing you want is old milk going everywhere when you start cutting them up.</samp></p>
<p class="bhead"><samp class="SANS_Milliard_ExtraLight_229">SEWING KIT</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Fabric scissors</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">It’s worth investing when it comes to fabric scissors, a good pair will give a nice clean cut and make your sewing life so much easier.</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Sewing machine</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">A lot of these projects have an element of sewing and getting to grips with a sewing machine is invaluable if you’re aiming for a zero waste lifestyle.</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Hand sewing</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">Embroidery needles are ideal for so many things. They usually have a big enough eye to take things like yarn instead of thread, but they are sharp enough to get through tougher fabrics like denim.</samp></p>
<p class="bhead"><samp class="SANS_Milliard_ExtraLight_229">OTHER TOOLS</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Bradawl</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">This is an incredibly useful little tool designed specifically for making holes in things. Bradawls can be bought from DIY or craft stores and are inexpensive.</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Crochet hooks</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">If you’ve never crocheted before a good average size hook for most yarns is a 5mm, grab one of these and you can use it on a DK yarn or an Aran weight. Hooks can be found in charity shops so there’s no need to buy new.</samp></p>
<p class="list-head"><samp class="SANS_Milliard_SemiBold_B_229">Pinking shears</samp></p>
<p class="list-no-bullet"><samp class="SANS_Milliard_Light_229">These are scissors that add a decorative edge to fabric and can also help prevent fraying.</samp></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tools_materials.vue?54ece55c